export default __webpack_public_path__ + "static/media/login-bg-47.c2fb5c41.jpg";